(function () {
  "use strict";

  /* ═══════════════════════════════════════════
     STYLES
     ═══════════════════════════════════════════ */
  var style = document.createElement("style");
  style.textContent =
    /* Scroll lock */
    "html.drawer-scroll-lock { overflow: hidden !important; }" +
    "html.drawer-scroll-lock body { overflow: hidden !important; touch-action: none; }" +

    /* Z-index fixes */
    "cart-drawer.active, cart-drawer.active .drawer__inner { z-index: 99999 !important; }" +
    "#CartDrawer-Overlay { z-index: 99998 !important; }" +

    /* Upsell styling */
    ".cart-drawer-upsell-list-item-left img { width: 80px !important; height: 80px !important; object-fit: cover; border-radius: 6px; }" +
    ".cart-drawer-upsell-list-item { max-width: 120px; }" +
    ".cart-drawer-upsell-list { gap: 10px !important; }" +
    ".cart-drawer-upsell-list-item button, .cart-drawer-upsell-list-item .button { font-size: 9px !important; padding: 6px 6px !important; white-space: nowrap !important; overflow: hidden !important; text-overflow: ellipsis !important; width: 100% !important; max-width: 100% !important; text-align: center !important; line-height: 1.2 !important; min-height: 30px !important; display: flex !important; align-items: center !important; justify-content: center !important; }" +
    ".cart-drawer-upsell-list-item-right { font-size: 11px !important; }" +
    ".cart-drawer-upsell-list-item-right .card-information__text { font-size: 11px !important; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }" +

    /* Hide default totals */
    "#CartDrawer .totals { display: none !important; }" +
    ".cart-drawer-upsell-title { color: #000 !important; }" +

    /* ── TIMER ── */
    ".drawer-timer {" +
      "text-align: center;" +
      "font-size: 13px;" +
      "font-weight: 600;" +
      "padding: 9px 16px;" +
      "color: #333;" +
      "background: #f5f5f5;" +
      "border-bottom: 1px solid #e5e5e5;" +
      "display: flex;" +
      "align-items: center;" +
      "justify-content: center;" +
      "gap: 6px;" +
      "letter-spacing: 0.01em;" +
    "}" +
    ".drawer-timer .timer-icon { font-size: 15px; line-height: 1; }" +
    ".drawer-timer .timer-digits {" +
      "font-variant-numeric: tabular-nums;" +
      "font-weight: 700;" +
      "color: #000;" +
      "min-width: 42px;" +
      "display: inline-block;" +
    "}" +
    ".drawer-timer--expired { color: #dc2626 !important; }" +
    ".drawer-timer--urgent .timer-digits { color: #dc2626 !important; }" +

    /* ── SAVINGS BAR ── */
    ".drawer-savings-text {" +
      "text-align: center;" +
      "color: #16a34a;" +
      "font-weight: 700;" +
      "font-size: 14px;" +
      "padding: 10px 16px 6px;" +
      "letter-spacing: 0.02em;" +
    "}" +
    ".drawer-savings-text .savings-amount { font-size: 16px; }";

  document.head.appendChild(style);

  /* ═══════════════════════════════════════════
     PROMO CALCULATION
     ═══════════════════════════════════════════ */
  function calculatePromo(productId, priceInCents) {
    var promoEuros = (productId % 15) + 20;
    if (promoEuros > 35) promoEuros = 35;
    var promoMaxCents = Math.floor((priceInCents * 45) / 55);
    var promoCents = promoEuros * 100;
    if (promoCents > promoMaxCents) {
      promoCents = promoMaxCents;
      promoEuros = Math.floor(promoCents / 100);
    }
    return { cents: promoCents, euros: promoEuros };
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace(".", ",") + "\u20AC";
  }

  /* ═══════════════════════════════════════════
     APPLY PROMOS TO DRAWER ITEMS
     ═══════════════════════════════════════════ */
  function applyPromosToDrawer() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = document.querySelectorAll("#CartDrawer .cart-item");
        if (!items.length) return;

        var totalSavings = 0;

        items.forEach(function (itemEl, index) {
          var cartItem = cart.items[index];
          if (!cartItem) return;

          var promo = calculatePromo(cartItem.product_id, cartItem.price);
          if (promo.cents <= 0 || promo.euros <= 0) return;

          totalSavings += promo.cents * cartItem.quantity;

          if (itemEl.getAttribute("data-promo-applied") === "true") return;

          var fakeCompare = cartItem.price + promo.cents;
          var fakeCompareLine = fakeCompare * cartItem.quantity;

          var details = itemEl.querySelector(".cart-item__details");
          if (details) {
            var priceOption = null;
            details.querySelectorAll(".product-option").forEach(function (opt) {
              if (!opt.querySelector("dt") && !priceOption) priceOption = opt;
            });
            if (priceOption && !priceOption.querySelector(".promo-drawer-badge")) {
              priceOption.innerHTML =
                '<s style="color:#999;font-size:0.9em;text-decoration:line-through;">' + formatMoney(fakeCompare) + '</s> ' +
                '<strong style="margin-left:4px;">' + formatMoney(cartItem.price) + '</strong> ' +
                '<span class="promo-drawer-badge" style="display:inline-block;margin-left:4px;font-size:0.75em;padding:2px 6px;background:#000;color:#fff;border-radius:2px;font-weight:600;">-' + promo.euros + '\u20AC</span>';
            }
          }

          var totals = itemEl.querySelector(".cart-item__price-wrapper");
          if (totals) {
            var priceEnd = totals.querySelector(".price.price--end");
            if (priceEnd && !priceEnd.querySelector(".promo-line-compare")) {
              priceEnd.innerHTML =
                '<span style="font-weight:600;">' + formatMoney(cartItem.price * cartItem.quantity) + '</span>' +
                '<s class="promo-line-compare" style="color:#999;font-size:0.85em;display:block;text-decoration:line-through;">' + formatMoney(fakeCompareLine) + '</s>';
            }
          }

          itemEl.setAttribute("data-promo-applied", "true");
        });

        addSavingsText(totalSavings);
      })
      .catch(function () {});
  }

  /* ═══════════════════════════════════════════
     SAVINGS TEXT
     ═══════════════════════════════════════════ */
  function addSavingsText(totalCents) {
    var footer = document.querySelector("#CartDrawer .cart-drawer__footer");
    if (!footer) footer = document.querySelector("#CartDrawer .drawer__footer");
    if (!footer) return;

    var existing = footer.querySelector(".drawer-savings-text");
    if (existing) existing.remove();
    if (totalCents <= 0) return;

    var savingsEl = document.createElement("div");
    savingsEl.className = "drawer-savings-text";
    savingsEl.innerHTML = 'Vous \u00E9conomisez <span class="savings-amount">' + formatMoney(totalCents) + '</span> sur votre commande';

    var ctas = footer.querySelector(".cart__ctas, .lumin-cart__ctas");
    if (ctas) {
      ctas.insertAdjacentElement("beforebegin", savingsEl);
    } else {
      footer.appendChild(savingsEl);
    }
  }

  /* ═══════════════════════════════════════════
     SCROLL LOCK (robust version)
     ═══════════════════════════════════════════ */
  var scrollY = 0;

  function lockScroll() {
    document.documentElement.classList.add("drawer-scroll-lock");
  }

  function unlockScroll() {
    document.documentElement.classList.remove("drawer-scroll-lock");
  }

  /* ═══════════════════════════════════════════
     TIMER
     ═══════════════════════════════════════════ */
  var TIMER_DURATION = 600; /* 10 minutes */
  var TIMER_KEY = "mh_cart_timer_end";
  var timerInterval = null;

  function getTimerEnd() {
    var stored = sessionStorage.getItem(TIMER_KEY);
    if (stored) {
      var end = parseInt(stored, 10);
      if (end > Date.now()) return end;
    }
    return null;
  }

  function resetTimer() {
    var end = Date.now() + TIMER_DURATION * 1000;
    sessionStorage.setItem(TIMER_KEY, end.toString());
  }

  function updateTimerDisplay() {
    var timerEl = document.querySelector("#CartDrawer .drawer-timer");
    if (!timerEl) return;

    var end = getTimerEnd();
    if (!end) {
      resetTimer();
      end = getTimerEnd();
    }
    if (!end) return;

    var remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
    var min = Math.floor(remaining / 60);
    var sec = remaining % 60;
    var timeStr = (min < 10 ? "0" : "") + min + ":" + (sec < 10 ? "0" : "") + sec;

    /* Urgency styling when < 2 minutes */
    timerEl.classList.toggle("drawer-timer--urgent", remaining > 0 && remaining < 120);
    timerEl.classList.toggle("drawer-timer--expired", remaining <= 0);

    if (remaining > 0) {
      timerEl.innerHTML =
        '<span class="timer-icon">\u23F1</span> Mon panier expirera dans <span class="timer-digits">' + timeStr + "</span>";
    } else {
      timerEl.innerHTML =
        '<span class="timer-icon">\u23F1</span> Votre panier a expir\u00E9';
    }
  }

  function startTimerTick() {
    if (timerInterval) clearInterval(timerInterval);
    timerInterval = setInterval(updateTimerDisplay, 1000);
  }

  function injectTimer() {
    /* Don't duplicate */
    var existingTimer = document.querySelector("#CartDrawer .drawer-timer");
    if (existingTimer) {
      updateTimerDisplay();
      startTimerTick();
      return;
    }

    var header = document.querySelector("#CartDrawer .drawer__header");
    if (!header) return;

    if (!getTimerEnd()) resetTimer();

    var timerEl = document.createElement("div");
    timerEl.className = "drawer-timer";
    header.insertAdjacentElement("afterend", timerEl);
    updateTimerDisplay();
    startTimerTick();
  }

  /* ═══════════════════════════════════════════
     HANDLE EMPTY CART
     ═══════════════════════════════════════════ */
  function handleEmptyCart() {
    var cartDrawer = document.getElementById("CartDrawer");
    if (!cartDrawer) return;

    var isEmpty =
      cartDrawer.querySelector(".drawer__inner.is-empty") ||
      cartDrawer.querySelector(".drawer__inner-empty") ||
      document.querySelector("cart-drawer.is-empty");

    var timer = cartDrawer.querySelector(".drawer-timer");
    if (timer) {
      timer.style.display = isEmpty ? "none" : "";
    }

    if (!isEmpty) return;

    /* Hide login/account links in empty cart */
    cartDrawer.querySelectorAll("a").forEach(function (a) {
      var href = a.getAttribute("href") || "";
      if (href.indexOf("account") !== -1 || href.indexOf("login") !== -1) {
        var p = a.closest("p");
        if (p) p.style.display = "none";
        if (p && p.previousElementSibling && p.previousElementSibling.tagName === "P") {
          var prevText = p.previousElementSibling.textContent || "";
          if (prevText.indexOf("compte") !== -1 || prevText.indexOf("Connectez") !== -1) {
            p.previousElementSibling.style.display = "none";
          }
        }
      }
    });
  }

  /* ═══════════════════════════════════════════
     INTERCEPT /cart/add TO RESET TIMER
     ═══════════════════════════════════════════ */
  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var urlStr = typeof url === "string" ? url : (url && url.url ? url.url : "");
    var result = originalFetch.apply(this, arguments);

    if (urlStr.indexOf("/cart/add") !== -1) {
      result
        .then(function (response) {
          if (response.ok) resetTimer();
          return response;
        })
        .catch(function () {});
    }

    return result;
  };

  /* ═══════════════════════════════════════════
     MUTATION OBSERVER
     ═══════════════════════════════════════════ */
  var isProcessing = false;

  function runPromos() {
    injectTimer();
    applyPromosToDrawer();
    handleEmptyCart();
  }

  function initObserver() {
    var drawer = document.querySelector("cart-drawer");
    if (!drawer) return;

    /* Watch open/close via class changes */
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === "class") {
          if (drawer.classList.contains("active")) {
            lockScroll();
            setTimeout(runPromos, 100);
          } else {
            unlockScroll();
          }
        }
      });
    }).observe(drawer, { attributes: true });

    /* Watch for content changes (cart update, item remove, etc.) */
    var cartDrawerEl = document.getElementById("CartDrawer");
    if (cartDrawerEl) {
      new MutationObserver(function () {
        if (!drawer.classList.contains("active") || isProcessing) return;
        isProcessing = true;

        cartDrawerEl.querySelectorAll("[data-promo-applied]").forEach(function (el) {
          el.removeAttribute("data-promo-applied");
        });

        setTimeout(function () {
          runPromos();
          setTimeout(function () {
            isProcessing = false;
          }, 200);
        }, 150);
      }).observe(cartDrawerEl, { childList: true, subtree: true });
    }

    /* If drawer is already open on page load (e.g. Shopify editor) */
    if (drawer.classList.contains("active")) {
      lockScroll();
      setTimeout(runPromos, 200);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initObserver);
  } else {
    initObserver();
  }
})();
